import { Link } from "react-router-dom";
import { Shield, Facebook, Linkedin, Twitter, Instagram, Youtube } from "lucide-react";

export function MobileFooter({ showComplianceBadges = true }: { showComplianceBadges?: boolean }) {
  return (
    <footer className="bg-muted/30 border-t mt-auto">
      <div className="container mx-auto px-4 py-8">
        {/* Logo & Tagline */}
        <div className="text-center mb-6">
          <Link to="/" className="inline-block">
            <h2 className="text-xl font-bold text-primary">PTC BRIDGE™</h2>
            <p className="text-xs text-muted-foreground mt-1 italic font-medium">
              Village to Verified: Africa's Fastest Clinical Pipeline
            </p>
          </Link>
        </div>

        {/* Compliance Badges */}
        {showComplianceBadges && <div className="flex flex-wrap justify-center gap-4 mb-6">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Shield className="h-4 w-4" />
            <span>HIPAA Compliant</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Shield className="h-4 w-4" />
            <span>GDPR Ready</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Shield className="h-4 w-4" />
            <span>FDA Guidelines</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <Shield className="h-4 w-4" />
            <span>21 CFR Part 11</span>
          </div>
        </div>}

        {/* Essential Links */}
        <div className="flex flex-wrap justify-center gap-4 mb-6 text-sm">
          <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
            About
          </Link>
          <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
            Contact
          </Link>
          <Link to="/help" className="text-muted-foreground hover:text-primary transition-colors">
            Help
          </Link>
          <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
            Privacy
          </Link>
          <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
            Terms
          </Link>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-4 mb-6">
          <a
            href="https://linkedin.com/company/ptc-bridge"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Linkedin className="h-5 w-5" />
          </a>
          <a
            href="https://facebook.com/ptcbridge"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Facebook className="h-5 w-5" />
          </a>
          <a
            href="https://twitter.com/ptcbridge"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Twitter className="h-5 w-5" />
          </a>
          <a
            href="https://instagram.com/ptcbridge"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Instagram className="h-5 w-5" />
          </a>
          <a
            href="https://youtube.com/@ptcbridge"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-primary transition-colors"
          >
            <Youtube className="h-5 w-5" />
          </a>
        </div>

        {/* Copyright */}
          <div className="text-center text-xs text-muted-foreground">
            © {new Date().getFullYear()} PTC BRIDGE™. All rights reserved.
          </div>
      </div>
    </footer>
  );
}
